<template>
  <div class="container">
    <label for="previewUrl">Enter the URL to preview</label>
    <input id="previewUrl" type="url" v-model="previewURL" @keyup="keyEvents" placeholder="https://yoursite.com.au"/>
    <button @click="submit">Go</button>
    <p class="error" v-if="errorMessage !== ''" v-html="errorMessage"></p>
    <h1>Previewer by <a target="_blank" href="https://joomstore.com.au" title="Joomstore"><img src="https://joomstore.com.au/templates/yootheme/cache/logo-92a4f263.webp" title="Joomstore" alt="Joomstore"></a></h1>
  </div>
</template>

<script>
  export default {
    name: "Start",
    data() {
      return {
        previewURL: '',
        errorMessage: ''
      }
    },
    mounted() {
    },
    methods: {
      submit: function () {
        console.log(this.previewURL);
        if (isValidURL(this.previewURL)) {
          window.location.href = this.previewURL;
        } else {
          console.log('Not Valid');
          this.errorMessage = "<i class=\"material-icons md-18\">error_outline</i> Not a valid URL"
        }
      },
      keyEvents: function (event) {
        this.errorMessage = '';
        if (event.key === "Enter") {
          this.submit();
        }
      }
    },
    beforeMount() {
      document.getElementsByTagName('body')[0].classList.add('start');
    },
    beforeDestroy() {
      document.getElementsByTagName('body')[0].classList.remove('start');
    },
  }

  function isValidURL(string) {
    try {
      new URL(string);
    } catch (_) {
      return false;
    }

    return true;
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Start.vue